import { jwtDecode } from "jwt-decode";

export interface IEmailSignInBody {
  email: string;
  client_id: string;
  redirect_uri: string;
  expiration_seconds: number;
  scope: string;
  state: string;
  nonce: string;
  remember_me: boolean;
}

export interface ICodeExchangeBody {
  grant_type: string;
  client_id: string;
  client_secret: string;
  redirect_uri: string;
  code: string;
}

export interface ITokenResponse {
  access_token: string;
  expires_in: number;
  refresh_expires_in: number;
  refresh_token: string;
  token_type: string;
  id_token: string;
  not_before_policy: number;
  session_state: string;
  scope: string;
}

export function getEmailFromTokenResponse(token: ITokenResponse): string {
  return jwtDecode<{ email: string }>(token.id_token).email;
}
